import { render, staticRenderFns } from "./LightPanelView.vue?vue&type=template&id=f3b43de0"
import script from "./LightPanelView.vue?vue&type=script&lang=js"
export * from "./LightPanelView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports